import { useAuth } from "react-oidc-context";
import { AppConfigService } from '@kf-react/config';
import axios from "axios";
import { type ApplicationConfig } from "@/core/domain/app.config";

export function useApiClient() {
  const auth = useAuth();
  const config = AppConfigService.getInstance<ApplicationConfig>()?.config;

  const apiKey = config?.wso2?.apikey;
  const apiBase = config?.services?.apiUrl;
  const contextApi = config?.services?.contextApi;

  const baseURL = apiBase && contextApi ? `${apiBase}/${contextApi}` : undefined;

  const api = axios.create({
    baseURL,
  });

  api.interceptors.request.use((req) => {
    if (apiKey) req.headers['Apikey'] = apiKey;
    if (auth.user?.access_token) req.headers['Authorization'] = `Bearer ${auth.user.access_token}`;
    return req;
  });

  return api;
}
